<template>
    <div class="px-6">
        <label for="audio_input">{{ trans('modules.Ai.audio_device') }}</label>
        <select
            v-if="audioDevices.length > 0"
            id="audio_input"
            name="audio_input"
            v-model="selectedAudioDevice"
            class="w-full form-control"
            :disabled="isRecording"
        >
            <option v-for="device in audioDevicesForSelect" :key="device.deviceId" :value="device">{{ device.label }}</option>
        </select>
        <div v-else-if="missingAudioPermission" class="mb-6">
            <missing-audio-permissions-notice @try-again="fetchAudioDevices" />
        </div>
        <div v-else>
            <p class="text-warning-500">{{ trans('modules.Ai.no_audio_device') }}</p>
        </div>
        <audio-meter
            v-if="selectedAudioDevice && showAudioMeter"
            :device-id="selectedAudioDevice.deviceId"
            @audio-denied="onAudioDenied"
        />
    </div>
</template>

<script setup>
import AudioMeter from './AudioMeter.vue';
import MissingAudioPermissionsNotice from './MissingAudioPermissionsNotice.vue';
import useAudioDevices from './composables/useAudioDevices';
import useTranscriptionSettings from './composables/useTranscriptionSettings';
import { watch } from 'vue';

// Define props
const props = defineProps({
    isRecording: {
        type: Boolean,
        default: false,
    },
    showAudioMeter: {
        type: Boolean,
        default: false,
    },
});

// Get audio devices from composable
const {
    audioDevices,
    selectedAudioDevice,
    missingAudioPermission,
    audioDevicesForSelect,
    fetchAudioDevices,
    onAudioDenied
} = useAudioDevices();

// Get transcription settings to update when device changes
const { audioDevice } = useTranscriptionSettings();

watch(selectedAudioDevice, (newDevice) => {
    if (newDevice) {
        // Update the device in the transcription settings
        audioDevice.value = newDevice;
    }
});
</script> 